import {create} from 'zustand';

/** PAG-01 — de que tipo de pedido veio esta sacola. */
export type SacolaPaymentMode = 'A_PRAZO' | 'A_VISTA';

interface ScheduledProposalStoreState {
  /** Proposta que originou a sacola atual, ou null. */
  proposalId: string | null;
  scheduledDate: string | null;
  /**
   * PAG-01 — `A_VISTA` quando a sacola veio de um PEDIDO A PAGAR.
   *
   * O checkout precisa disto para oferecer apenas PIX. Boleto e cartão não são
   * uma limitação de tela: o backend os RECUSA com 422 para o à vista, porque
   * boleto marca o pedido como enviado na confirmação do PEDIDO e faria o
   * Conecta Sales anunciar ao vendedor um pagamento que não aconteceu.
   *
   * Mora aqui, e não em parâmetro de navegação, pelo mesmo motivo do
   * `proposalId`: precisa sobreviver a Sacola -> Checkout -> escolha do meio de
   * pagamento, e o checkout tem três caminhos de finalização.
   */
  paymentMode: SacolaPaymentMode;
  setProposal: (
    proposalId: string,
    scheduledDate: string,
    paymentMode?: SacolaPaymentMode,
  ) => void;
  clear: () => void;
}

/**
 * PED-13 / CB-4 — carrega o vínculo da proposta entre a sacola e o checkout.
 *
 * O `proposalId` não vai por parâmetro de navegação porque precisa sobreviver a
 * Sacola -> Checkout -> escolha do meio de pagamento, e o checkout tem três
 * caminhos de finalização. Um store dedicado evita enfiar o id em toda a
 * cadeia de params.
 *
 * Limpar é obrigatório ao finalizar o pedido e ao esvaziar a sacola: um id
 * sobrando marcaria o PRÓXIMO pedido do cliente como aceite de uma proposta
 * que ele já respondeu.
 */
export const useScheduledProposalStore = create<ScheduledProposalStoreState>(
  set => ({
    proposalId: null,
    scheduledDate: null,
    // O default é o mundo de antes de PAG-01: toda sacola que não se declara é
    // a prazo, e o checkout segue oferecendo os três meios.
    paymentMode: 'A_PRAZO',

    setProposal: (proposalId, scheduledDate, paymentMode = 'A_PRAZO') =>
      set({proposalId, scheduledDate, paymentMode}),

    clear: () =>
      set({proposalId: null, scheduledDate: null, paymentMode: 'A_PRAZO'}),
  }),
);
